export default class DuplicateSubscriberError extends Error {}
